module.exports = "/static/img/play.svg?a2c759de3d3d2177fc942f6d4688bd18";